module.exports = __webpack_public_path__ + "img/uli-pro.549c4654.jpg";